// src/Base.js
import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import CookieConsentOverlay from "./components/CookieConsentOverlay";
import CookiePreferences from "./components/CookiePreferences";
import UserProfile from "./components/UserProfile";
import AuthSuccess from "./components/AuthSuccess";
import CarSenseUI from "./CarSenseUI";
import Results from "./Results";
import ManualSearch from "./ManualSearch";
import ManualResults from "./ManualResults";
import ErrorPage from "./ErrorPage";

// Start each new page at the top, unless the link points at a section (e.g. /#pricing).
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function Base() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<CarSenseUI />} />
        <Route path="/results" element={<Results />} />
        <Route path="/sample-report" element={<Results key="sample" sample />} />
        <Route path="/manual-search" element={<ManualSearch />} />
        <Route path="/manual-results" element={<ManualResults />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/auth-success" element={<AuthSuccess />} />
        <Route path="/auth-error" element={<AuthSuccess failed />} />
        <Route path="/cookie-preferences" element={<CookiePreferences />} />
        <Route path="/error" element={<ErrorPage />} />

        {/* Old addresses (/landing, /home, /about-us, ...) go to the new home page. */}
        <Route path="/registration-search" element={<Navigate to="/#search" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <CookieConsentOverlay />
    </>
  );
}

export default Base;
